var selectElementParent = document.getElementById('select_size_dropdown');
const selectElement = selectElementParent.childNodes[1];
const select_size = document.querySelector('.size_sel');
var select_value = select_size.value;
const selectedOption = select_size.querySelector(`option[value="${select_value}"]`);
const select_una = selectedOption.getAttribute('data-una');
if(select_una == 'unavaible'){
  //console.log(select_una);

    for (var optt, j = 0; optt = select_size[j]; j++) {
        if(optt.dataset.una == undefined){
              select_value = optt.value;
              selectElement.value = select_value;
              selectElement.dispatchEvent(new Event('change', { bubbles: true }));
              console.log(selectElement.value);
              break;
         }
    }
}
var size_text;
switch (true) {
    case select_value == 'XS':
        size_text = 'X-Small'
        break;
    case select_value == 'SM':
        size_text = 'Small'
        break;
    case select_value == 'MD':
        size_text = 'Medium'
        break;
    case select_value == 'LG':
        size_text = 'Large'
        break;      
    case select_value == 'XL':
        size_text = 'X-Large'
        break; 
    case select_value == '2X':
        size_text = '2X-Large'
        break;             
}

document.getElementById("size_in_button").innerHTML = size_text;
const button_size = document.getElementById("option-size");
const option_menu_size = document.getElementById("option-size-menu");
const option_note =  document.getElementById("option_note");
const row = document.getElementById('checkrow');


button_size.onclick = function() {
    this.classList.add("dnone");
    option_menu_size.classList.remove("dnone");
    option_note.classList.remove("dnone");
};

option_menu_size.querySelector('#head_block').onclick = function() {
    this.parentNode.classList.add("dnone");
    button_size.classList.remove("dnone");
    option_note.classList.add("dnone");
};

var k = 0;
for (var opt, j = 0; opt = select_size[j]; j++) {
    if(opt.dataset.una == undefined){
    k++;
    }
}

for (var opt, l = 0, j = 0; opt = select_size[j]; j++) {
    //console.log(k);
    if(opt.dataset.una == undefined){
    document.querySelector('[data-drop="'+opt.value+'"]').classList.remove("dnone");
    l++;
    }
    if(l == (k)){
        document.querySelector('[data-drop="'+opt.value+'"]').classList.add("lastrow");
    }
    if(opt.value == select_value){
        document.querySelector('[data-drop="'+opt.value+'"]').classList.add("active");
    }
}

row.addEventListener('click', function(event) {
     if (event.target.classList.contains('row')) {
        const clickedElement = event.target;
        const dropId = clickedElement.dataset.drop;
        selectElement.value = dropId;
        selectElement.dispatchEvent(new Event('change', { bubbles: true }));
     }
    if (event.target.classList.contains('cell')) {
        const clickedChild = event.target;
        const parentElement = clickedChild.parentElement;
        const dropId = parentElement.dataset.drop;
        selectElement.value = dropId;
        console.log(dropId);
        selectElement.dispatchEvent(new Event('change', { bubbles: true }));
    }

});

    var messages = document.querySelectorAll(".reginal");
    for (var i = 0; i < messages.length; i++) {
        var str = messages[i].innerHTML.replace('®', '<span class="text-registered">®</span>');
        messages[i].innerHTML = str;
    }



function moveBlockResponsive(config) {
    const {
        blockSelector,
        desktopSelector,
        mobileSelector,
        breakpoint = 750
    } = config;
    
    const block = document.querySelector(blockSelector);
    const desktopContainer = document.querySelector(desktopSelector);
    const mobileContainer = document.querySelector(mobileSelector);
    
    if (!block || !desktopContainer || !mobileContainer) {
        console.warn('Элементы для перемещения не найдены');
        return;
    }
    
   
    let resizeTimeout;
    function checkAndMove() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const isMobile = window.innerWidth <= breakpoint;
            const targetContainer = isMobile ? mobileContainer : desktopContainer;
            
           
            if (block.parentNode !== targetContainer) {
                targetContainer.appendChild(block);
                
                
                block.classList.add('block-moved');
                setTimeout(() => block.classList.remove('block-moved'), 300);
            }
        }, 100);
    }
    
    checkAndMove();
    
    window.addEventListener('resize', checkAndMove);
    
    return { checkAndMove };
}

document.addEventListener('DOMContentLoaded', () => {
    const mover = moveBlockResponsive({
        blockSelector: '#pd_gallery_inside',
        desktopSelector: '#pd_gallery',
        mobileSelector: '#for_mg',
        breakpoint: 751
    });
});








